import { checkCreatedTreeObject, setActiveEntity, useAppDispatch } from '@core/core/store'
import type { SelectedTreeObject } from '@core/core/types'
import type { MessageHandler } from 'common/messenger'
import { messengerRef } from 'common/messenger'
import type { ProjectId } from 'common/types'
import { useEffect } from 'react'

/**
 * Хук нужен для подписки на события, которые не зависят от вкладок
 *
 * То есть вкладка либо берется внутри обработчика, либо вкладка вообще не нужна
 */
export const useProjectMessageSubscription = (projectId: ProjectId) => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    const onTreeNodeSelected: MessageHandler<'elementSelected'> = ({ payload }) => {
      const { entityId, entityType, entityName } = payload
      const treeObject: SelectedTreeObject = {
        entityId,
        entityType,
        entityName,
      }

      dispatch(setActiveEntity(treeObject))
    }
    const unsubscribe = messengerRef.current?.subscribe('elementSelected', onTreeNodeSelected)

    return unsubscribe
  }, [])

  const onMarkerCreated: MessageHandler<'markerCreated'> = ({ payload }) => {
    // вкладка берется внутри checkCreatedTreeObject
    dispatch(checkCreatedTreeObject(projectId, payload, 'marker'))
  }

  useEffect(() => {
    const unsubscribe = messengerRef.current?.subscribe('markerCreated', onMarkerCreated)

    return unsubscribe
  }, [])

  useEffect(() => {
    const unsubscribe = messengerRef.current?.subscribe('markerSelected', onMarkerCreated)

    return unsubscribe
  }, [])
}
